import { useSelector } from "react-redux";
import { RootState } from "../../..";
import { AlertDialog } from "../../Dialogs/AlertDialog";
import { useLocation, useNavigate } from "react-router-dom";
import { handleCloseDialog, saveExam } from "../Functions/FunctionsMain";
import { DIALOGS } from "../../Dialogs/dialogReducer";

const NoObjectivesSelectedDialog = ({ open, handleConfirm }: { open: boolean; handleConfirm: () => void }) => {
  const nameChanged = useSelector((state: RootState) => state.examBuilder.main.nameChanged);
  const examData = useSelector((state: RootState) => state.examBuilder.main.examData);
  const location = useLocation();
  const pathString = decodeURI(location.pathname.replace("/exam-builder", "")) || "/";
  const navigate = useNavigate();

  const user = useSelector((state: RootState) => state.app.user);
  const userId = user?.uid;

  async function saveAndNavigateToOverview() {
    if (userId) {
      handleCloseDialog(DIALOGS.SELECT_TOPICS_EXAM_DIALOG);
      handleCloseDialog(DIALOGS.NO_OBJECTIVE_SELECTED_DIALOG);
      await saveExam(userId, nameChanged, examData, pathString);
      navigate("/exam-overview");
    } else {
      console.error("No User ID provided.");
    }
  }

  return (
    <AlertDialog
      open={open}
      handleClose={() => saveAndNavigateToOverview()}
      handleConfirm={() => handleConfirm()}
      title={`Gib deinen Kids eine Chance...`}
      text={`Wähle mindestens eine Kompetenz aus der Liste aus.`}
      cancelTitle="Zurück zur Übersicht"
      confirmTitle="OK"
    />
  );
};

export default NoObjectivesSelectedDialog;
